goog.provide('el8.appchart.dialog.createLabResultTest');

goog.require('el8.appservice.notifier');
goog.require('el8.appshared.dialog.createLabResultVendor');
goog.require('el8.template.appchart.dialog.createLabResultTest');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.util.consts');


el8.appchart.dialog.createLabResultTest = (function(){

    var saveCallbackFn = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Create New Lab Result Test',
        modal: true,
        position: 'center',
        autoHeight: true,
        width: 615,
        contentFn: el8.template.appchart.dialog.createLabResultTest.content
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'testName',
                selector: ':input[name="testName"]',
                infoText: 'e.g., LDL...',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                maxLength: 100
            },
            {
                name: 'loincCode',
                selector: ':input[name="loincCode"]',
                infoText: "trend with other vendors' tests...",
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT
            },
            {
                name: 'vendorId',
                selector: ':input[name="vendorId"]'
                //hidden field
            },
            {
                name: 'categoryId',
                selector: ':input[name="categoryId"]'
                //hidden field
            }
        ]
    });

    form.addButton('save', 'Create Lab', function(_form) {
        el8.appservice.notifier.notify('Creating new lab test...');
        $.el8_ajax({
            url: el8.service.urls.get('labTests'),
            type: 'POST',
            data: {'data': JSON.stringify(_form.getMapped(true, true))},
            success: function(data) {
                el8.appservice.notifier.notify('New lab test created.');
                that.hide();
                if (saveCallbackFn) { saveCallbackFn(data); }
            },
            error_override: function(data) {
                if (data.status === 400) { //bad request: using this for invalid LOINC
                    el8.uiwidget.alert('Please enter a valid LOINC code or leave this field blank.',
                        form.getInputField('loincCode'));
                } else {
                    el8.uiwidget.alert('An error occurred while trying to save this labtest. Please contact Support if this error persists.');
                }
            }
        });
    }, true);
    form.addDiscardButton(function() {
        that.hide();
    }, false);
    that.setForm(form);

    var super_show = that.show;
    that.show = function(opts) {
        opts = opts || {};
        if (!opts.vendor || !opts.panel) { return; }
        
        super_show.call(that);
        if (opts.defaultLabName) {
            form.setVal('testName', opts.defaultLabName);
        }
        form.setVal('vendorId', opts.vendor.id);
        form.setVal('categoryId', opts.panel.id);
        $('.vendor-name', that.getContainer()).text(opts.vendor.name);
        $('.panel-name', that.getContainer()).text(opts.panel.name);
        saveCallbackFn = opts.saveCb || null;
        that.adjustHeight();
    };

    return that;
})();
